export default "/images/map-pin.svg?8c41fcd32a64210260619a622335959e";